module.exports = __webpack_public_path__ + "img/grey-canadian-goose-down.c63e628.svg";